let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fRrVk")).then(() => parcelRequire('9YVlR'));